//@flow
import React, { Fragment } from 'react';

import OfficeCategory from './OfficeCategory.react';
import _ from 'underscore';

import type CategoryModel from '../../Stores/MemberCategories/categoryModel';
import type ProductsCollection from '../../Stores/Products/productsCollection';
import type StockCollection from '../../Stores/Stock/stockCollection';

type Props = {
  categories:CategoryModel[],
  products:ProductsCollection,
  stock:StockCollection,
  filterByStock:boolean,
  useSingleGrouping:boolean,
};

function _renderCategory(category:CategoryModel, props:Props) {
  const {
    stock,
    products,
    filterByStock,
  } = props;
  return (
    <OfficeCategory
      key={category.getUrlKey()}
      category={category}
      products={products}
      stock={stock}
      filterByStock={filterByStock}
    />
  );
}

export default function OfficeCatalog(props:Props):React$Node {
  const {
    useSingleGrouping,
    filterByStock,
    stock,
    categories,
    products,
  } = props;

  if (useSingleGrouping) {
    const allSkus = _.flatten(categories.map(category => category.getProductsSkus()));
    return (
      <Fragment>
        <div className="office-catalog-container">
          <OfficeCategory
            title="Bulk Snack Pantry Selections"
            skus={_.uniq(allSkus)}
            stock={stock}
            products={products}
            filterByStock={filterByStock}
          />
        </div>
      </Fragment>
    );
  }
  else {
    return (
      <Fragment>
        {categories.map(category => _renderCategory(category, props))}
      </Fragment>
    );
  }
}
